<template>
    <nav class="mt-8 flex-1 px-2 space-y-1" ref="navigation">
        <template v-for="(menuItem, index) in menu">
            <Link v-if="menuItem.hasOwnProperty('route')"
                  :key="index"
                  :href="$route(menuItem.route)"
                  v-on:click="navigateTo(menuItem.route)"
                  class="text-white hover:bg-cyan-500 hover:text-white group flex items-center px-2 py-2 text-base font-medium"
                  :class="{'pl-5' : menuItem.indent === 1, 'pl-10' : menuItem.indent === 2, 'router-link-active' : isActive(menuItem.route)}"
            >
                <span class="w-8 text-center mr-3">
                    <icon :name="menuItem.icon"
                          class="w-6 h-6 m-auto "
                          :class="menuIconClass(menuItem)" />
                </span>
                <span>{{menuItem.label}}</span>
            </Link>
            <span v-if="!menuItem.route" class="text-gray-300 hover:bg-gray-700 hover:text-white group flex items-center px-2 py-2 text-base">{{menuItem.label}}</span>
        </template>

        <beta v-if="showBetaHint"/>
    </nav>
</template>

<script>
import Icon from '@/Shared/Icon'
import Beta from '@/Shared/Beta'
import { Link } from '@inertiajs/vue2';


export default {
    components: {
        Icon,
        Link,
        Beta
    },
    props: {
        menu: Array
    },
    data() {
      return {
          env: window.env,
      }
    },
    methods: {
        navigateTo(path) {
            this.$emit('navigateTo', path);
        },
        isActive(path) {
            return path && (this.getPath().substring(0, this.route(path).length) === this.route(path));
        },
        getPath() {
            const url = new URL(window.location.href);
            return url.origin + url.pathname;
        },
        menuIconClass(menuItem) {
            let classes = {
                'fill-white' : this.isActive(menuItem.route),
                'fill-gray-300 group-hover:fill-white' : !this.isActive(menuItem.route)

            }
            if(menuItem.hasOwnProperty('iconClass')){
                classes[menuItem.iconClass] = true;
            }
            return classes;
        }
    },
    computed: {
        showBetaHint() {
            return this.$inertia.page.props.tenant.misc.show_beta_hint;
        }
    }
}
</script>
